import * as React from 'react'
import { AssetsClassificationContext } from '../context/AssetsClassificationContext'

const useAssetsClassificationContext = () => {
    return React.useContext(AssetsClassificationContext)
}

export default useAssetsClassificationContext
